import { Action, Reducer } from 'redux'
import { AM_QUOTING_ACTION_TYPES } from './actions'
import { IAmQuotingState, ISpotRate, IOpportunity } from './types'

const {
  AM_QUOTING_TOOL_FAILURE,
  AM_QUOTING_TOOL_REQUEST,
  AM_QUOTING_TOOL_SUCCESS,
} = AM_QUOTING_ACTION_TYPES

const defaultState = {
  opportunity: {},
  fetching: false,
} as IAmQuotingState

interface IRequestAction extends Action<string> {
  payload: {
    requestData: {
      body: {
        opportunity: IOpportunity
      }
    }
  }
}

interface IErrorAction extends Action<string> {
  error: string
}

interface ISuccessAction extends Action<string> {
  payload: ISpotRate
}

type AmQuotingAction = Action<string> | IErrorAction | ISuccessAction

const amQuotingReducer: Reducer<IAmQuotingState, AmQuotingAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case AM_QUOTING_TOOL_REQUEST: {
      const {
        payload: {
          requestData: {
            body: { opportunity },
          },
        },
      } = action as IRequestAction
      return {
        ...state,
        opportunity,
        fetching: true,
        error: undefined,
      }
    }
    case AM_QUOTING_TOOL_SUCCESS: {
      const { payload: spotRate } = action as ISuccessAction
      return {
        ...state,
        spotRate,
        fetching: false,
      }
    }

    case AM_QUOTING_TOOL_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }

    default:
      return state
  }
}

export default amQuotingReducer
